<div class="PageContent">
  <!-- Header -->
  <div class="tracking-header">
    <h2>B2B User Tracking</h2>
  </div>

  <!-- Main Tabs: Searches / Statistics -->
  <div class="GridModeTabsWrapper">
    <div class="GridModeTab" [class.SelectedGridModeTab]="mainTab === 'searches'" (click)="mainTab = 'searches'">
      <i class="material-icons">search</i>
      <span>{{ 'B2BTracking.Searches' | translate }}</span>
    </div>
    <div class="GridModeTab" [class.SelectedGridModeTab]="mainTab === 'statistics'" (click)="mainTab = 'statistics'; OnStatisticsTabClick()">
      <i class="material-icons">bar_chart</i>
      <span>{{ 'B2BTracking.Statistics' | translate }}</span>
    </div>
    <div class="GridModeTab" [class.SelectedGridModeTab]="mainTab === 'screenshots'" (click)="mainTab = 'screenshots'; OnScreenshotsTabClick()">
      <i class="material-icons">screenshot_monitor</i>
      <span>{{ 'B2BTracking.Screenshots' | translate }}</span>
    </div>
  </div>

  <!-- Searches Tab Content -->
  <div class="TabContent" *ngIf="mainTab === 'searches'">

    <!-- Filter Panel (Always Visible) -->
    <div class="filter-panel open">
    <div class="filter-panel-content">
      <h3>Filter Tracking Data</h3>

      <!-- First Row: Standard Filters -->
      <div class="filter-grid">
        <!-- Event Type - Custom Dropdown -->
        <div class="filter-field">
          <label>Event Type</label>
          <div class="CustomDropdownContainer">
            <div class="CustomDropdownBar" (click)="showEventTypeDropdown = !showEventTypeDropdown">
              <i class="material-icons dropdown-icon-left">event</i>
              <input type="text" class="CustomDropdownInput" [class.placeholder]="!Filter.EventType"
                     [value]="Filter.EventType?.Name || 'All'" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="CustomDropdownResults" *ngIf="showEventTypeDropdown">
              <div class="CustomDropdownResult" (click)="SelectEventType(null)">
                <div class="CustomDropdownResultMain">
                  <span class="CustomDropdownResultText">All</span>
                </div>
              </div>
              <div class="CustomDropdownResult" (click)="SelectEventType({ID: 1, Name: 'Keyboard'})">
                <div class="CustomDropdownResultMain">
                  <i class="material-icons">keyboard</i>
                  <span class="CustomDropdownResultText">Keyboard</span>
                </div>
              </div>
              <div class="CustomDropdownResult" (click)="SelectEventType({ID: 2, Name: 'Copy/Paste (Keyboard)'})">
                <div class="CustomDropdownResultMain">
                  <i class="material-icons">content_copy</i>
                  <span class="CustomDropdownResultText">Copy/Paste (Keyboard)</span>
                </div>
              </div>
              <div class="CustomDropdownResult" (click)="SelectEventType({ID: 3, Name: 'Copy/Paste (Mouse)'})">
                <div class="CustomDropdownResultMain">
                  <i class="material-icons">mouse</i>
                  <span class="CustomDropdownResultText">Copy/Paste (Mouse)</span>
                </div>
              </div>
              <div class="CustomDropdownResult" (click)="SelectEventType({ID: 4, Name: 'Export PDF'})">
                <div class="CustomDropdownResultMain">
                  <i class="material-icons">picture_as_pdf</i>
                  <span class="CustomDropdownResultText">Export PDF</span>
                </div>
              </div>
              <div class="CustomDropdownResult" (click)="SelectEventType({ID: 5, Name: 'Export XLSX'})">
                <div class="CustomDropdownResultMain">
                  <i class="material-icons">table_chart</i>
                  <span class="CustomDropdownResultText">Export XLSX</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- From Date -->
        <div class="filter-field">
          <label>From Date</label>
          <div class="PartnerSearchBar">
            <i class="material-icons search-icon">calendar_today</i>
            <input matInput [matDatepicker]="pickerFrom" [formControl]="FromDate" placeholder="From Date" class="PartnerSearchInput">
            <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
            <mat-datepicker #pickerFrom></mat-datepicker>
          </div>
        </div>

        <!-- To Date -->
        <div class="filter-field">
          <label>To Date</label>
          <div class="PartnerSearchBar">
            <i class="material-icons search-icon">calendar_today</i>
            <input matInput [matDatepicker]="pickerTo" [formControl]="ToDate" placeholder="To Date" class="PartnerSearchInput">
            <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
            <mat-datepicker #pickerTo></mat-datepicker>
          </div>
        </div>

        <!-- Partner -->
        <div class="filter-field">
          <label>Partner</label>
          <div class="PartnerSearchContainer">
            <div class="PartnerSearchBar">
              <i class="material-icons search-icon">business</i>
              <input
                type="text"
                class="PartnerSearchInput"
                [(ngModel)]="PartnerSearchTerm"
                (input)="GetPartnersFiltered(PartnerSearchTerm)"
                placeholder="Search partner..."
              />
              <i *ngIf="Filter.Partner" class="material-icons clear-icon" (click)="ClearPartner()">close</i>
            </div>
            <div class="PartnerSearchResults" *ngIf="Partners.length > 0">
              <div
                *ngFor="let partner of Partners"
                class="PartnerSearchResult"
                (click)="SelectPartner(partner)"
              >
                <div class="PartnerResultMain">
                  <span class="PartnerName">{{ partner.Name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Country -->
        <div class="filter-field">
          <label>Country</label>
          <div class="PartnerSearchContainer">
            <div class="PartnerSearchBar">
              <i class="material-icons search-icon">public</i>
              <input
                type="text"
                class="PartnerSearchInput"
                [(ngModel)]="CountrySearchTerm"
                (input)="GetCountriesFiltered(CountrySearchTerm)"
                placeholder="Search country..."
              />
              <i *ngIf="Filter.Country" class="material-icons clear-icon" (click)="ClearCountry()">close</i>
            </div>
            <div class="PartnerSearchResults" *ngIf="Countries.length > 0">
              <div
                *ngFor="let country of Countries"
                class="PartnerSearchResult"
                (click)="SelectCountry(country)"
              >
                <div class="PartnerResultMain">
                  <span class="PartnerName">{{ country.Name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- User -->
        <div class="filter-field">
          <label>User</label>
          <div class="PartnerSearchContainer">
            <div class="PartnerSearchBar">
              <i class="material-icons search-icon">person</i>
              <input
                type="text"
                class="PartnerSearchInput"
                [(ngModel)]="UserSearchTerm"
                (input)="GetUsersFiltered(UserSearchTerm)"
                placeholder="Search user..."
              />
              <i *ngIf="Filter.User" class="material-icons clear-icon" (click)="ClearUser()">close</i>
            </div>
            <div class="PartnerSearchResults" *ngIf="Users.length > 0">
              <div
                *ngFor="let user of Users"
                class="PartnerSearchResult"
                (click)="SelectUser(user)"
              >
                <div class="PartnerResultMain">
                  <span class="PartnerName">{{ user.Email }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Grid ID -->
        <div class="filter-field">
          <label>Grid ID</label>
          <div class="PartnerSearchBar">
            <i class="material-icons search-icon">grid_on</i>
            <input type="text" class="PartnerSearchInput" [(ngModel)]="Filter.GridID" placeholder="Enter Grid ID...">
          </div>
        </div>
      </div>

      <!-- Second Row: Search Filters -->
      <div class="search-filters">
        <div class="filter-field" style="flex: 1;">
          <label>Brand</label>
          <div class="PartnerSearchBar">
            <i class="material-icons search-icon">local_offer</i>
            <input
              type="text"
              class="PartnerSearchInput"
              [(ngModel)]="Filter.Brand"
              (ngModelChange)="OnSearchFieldChange()"
              placeholder="Search by Brand..."
            />
            <i *ngIf="Filter.Brand" class="material-icons clear-icon" (click)="ClearSearchField('Brand')">close</i>
          </div>
        </div>

        <div class="filter-field" style="flex: 1;">
          <label>Part Number</label>
          <div class="PartnerSearchBar">
            <i class="material-icons search-icon">tag</i>
            <input
              type="text"
              class="PartnerSearchInput"
              [(ngModel)]="Filter.PartNumber"
              (ngModelChange)="OnSearchFieldChange()"
              placeholder="Search by Part Number..."
            />
            <i *ngIf="Filter.PartNumber" class="material-icons clear-icon" (click)="ClearSearchField('PartNumber')">close</i>
          </div>
        </div>

        <div class="filter-field" style="flex: 1;">
          <label>Product Name</label>
          <div class="PartnerSearchBar">
            <i class="material-icons search-icon">inventory_2</i>
            <input
              type="text"
              class="PartnerSearchInput"
              [(ngModel)]="Filter.ProductName"
              (ngModelChange)="OnSearchFieldChange()"
              placeholder="Search by Product Name..."
            />
            <i *ngIf="Filter.ProductName" class="material-icons clear-icon" (click)="ClearSearchField('ProductName')">close</i>
          </div>
        </div>
      </div>

      <div class="filter-actions">
        <button class="GridCommandButton GridCommandButtonBlue" (click)="ApplyFilter()">
          <i class="material-icons">search</i>
          <span>Apply Filter</span>
        </button>
        <button class="GridCommandButton" (click)="ClearFilter()" title="Clear all filters">
          <i class="material-icons">close</i>
          <span>Clear</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Loading Indicator -->
  <div *ngIf="loading" class="loading-overlay">
    <div class="spinner"></div>
  </div>

  <!-- Tabs -->
  <div class="tabs-container">
    <div class="tabs">
      <button
        class="tab-button"
        [class.active]="activeTab === 'list'"
        (click)="SwitchTab('list')"
      >
        <i class="material-icons">list</i>
        Event List
      </button>
      <button
        class="tab-button"
        [class.active]="activeTab === 'map'"
        (click)="SwitchTab('map')"
      >
        <i class="material-icons">map</i>
        Map ({{ GetEventsWithCoordinates().length }})
      </button>
    </div>
  </div>

  <!-- Events List Tab -->
  <div class="events-section" *ngIf="!loading && activeTab === 'list'">
    <h3>Tracking Events ({{ FormatNumber(Filter.Pager.TotalCount) }})</h3>

    <!-- Table Header -->
    <div class="events-table-header" *ngIf="TrackingGrids && TrackingGrids.length > 0">
      <div class="col-icon"></div>
      <div class="col-event-type">Event Type</div>
      <div class="col-date">Date & Time</div>
      <div class="col-partner">Partner</div>
      <div class="col-user">User</div>
      <div class="col-grid-id">Grid ID</div>
    </div>

    <!-- Table Rows -->
    <div class="events-table" *ngIf="TrackingGrids && TrackingGrids.length > 0">
      <ng-container *ngFor="let grid of TrackingGrids">
        <!-- Tracking Row -->
        <div
          class="event-row"
          [class.selected]="SelectedGrid?.EventID === grid.EventID"
          (click)="SelectGrid(grid)"
        >
          <div class="col-icon">
            <i class="material-icons">{{ SelectedGrid?.EventID === grid.EventID ? 'expand_more' : 'chevron_right' }}</i>
          </div>
          <div class="col-event-type">{{ GetEventTypeName(grid.EventType) }}</div>
          <div class="col-date">{{ FormatDate(grid.EventRegister) }}</div>
          <div class="col-partner">{{ grid.PartnerName || 'N/A' }}</div>
          <div class="col-user">{{ grid.IncomingEmailAddress || 'N/A' }}</div>
          <div class="col-grid-id">{{ grid.GridID }}</div>
        </div>

        <!-- Expanded Detail Section (inline below the clicked row) -->
        <div class="event-detail-expanded" *ngIf="SelectedGrid?.EventID === grid.EventID">
          <!-- Grid Detail Header -->
          <div class="grid-detail-inline-header">
            <div class="grid-detail-title">
              <h3>{{ grid.PartnerName || 'N/A' }}</h3>
              <span class="grid-id-small">Grid ID: {{ grid.GridID }}</span>
            </div>
            <div class="grid-detail-inline-info">
              <span><i class="material-icons">person</i> {{ grid.IncomingEmailAddress || 'N/A' }}</span>
              <span><i class="material-icons">event</i> {{ FormatDate(grid.EventRegister) }}</span>
            </div>
          </div>

          <!-- Loading Indicator -->
          <div *ngIf="loadingGridLines" class="loading-inline">
            <div class="spinner-small"></div>
            <span>Loading events...</span>
          </div>

          <!-- Events grouped by EventID -->
          <div *ngIf="!loadingGridLines && GroupedEvents && GroupedEvents.length > 0">
            <div *ngFor="let event of GroupedEvents" class="event-group-inline">
              <div class="event-group-header-inline">
                <div class="event-group-title-inline">
                  <i class="material-icons">{{ event.EventType?.ID === 4 || event.EventType?.ID === 5 ? 'download' : 'edit' }}</i>
                  <h4>{{ GetEventTypeName(event.EventType) }}</h4>
                  <span class="event-group-date-inline">{{ FormatDate(event.EventRegister) }}</span>
                </div>
                <span class="badge-inline">{{ event.Lines?.length || 0 }} lines</span>
              </div>

              <!-- AG Grid for this event -->
              <ag-grid-angular
                style="width: 100%;"
                class="ag-theme-alpine"
                [rowData]="event.Lines | eventLinesToGridRows"
                [columnDefs]="columnDefs"
                [gridOptions]="gridOptions"
                [defaultColDef]="{
                  sortable: true,
                  filter: true,
                  resizable: true
                }"
              >
              </ag-grid-angular>
            </div>
          </div>

          <!-- No events found -->
          <div *ngIf="!loadingGridLines && (!GroupedEvents || GroupedEvents.length === 0)" class="no-data-inline">
            <i class="material-icons">inbox</i>
            <p>No events found for this grid</p>
          </div>
        </div>
      </ng-container>
    </div>

    <div *ngIf="!TrackingGrids || TrackingGrids.length === 0" class="no-data">
      <i class="material-icons">inbox</i>
      <p>No tracking data found</p>
    </div>

    <!-- Pagination -->
    <div class="pagination" *ngIf="Filter.Pager.Pages && Filter.Pager.Pages.length > 1">
      <button
        class="page-btn"
        [disabled]="Filter.Pager.PageIndex === 1"
        (click)="ChangePage(Filter.Pager.PageIndex - 1)"
      >
        <i class="material-icons">chevron_left</i>
      </button>

      <button
        *ngFor="let page of Filter.Pager.Pages"
        class="page-btn"
        [class.active]="page === Filter.Pager.PageIndex"
        (click)="ChangePage(page)"
      >
        {{ page }}
      </button>

      <button
        class="page-btn"
        [disabled]="Filter.Pager.PageIndex === Filter.Pager.Pages.length"
        (click)="ChangePage(Filter.Pager.PageIndex + 1)"
      >
        <i class="material-icons">chevron_right</i>
      </button>
    </div>
  </div>

  <!-- Map Tab -->
  <div class="map-section" *ngIf="activeTab === 'map'">
    <div class="map-info">
      <h3>Tracking Events Map</h3>
      <p *ngIf="!loading">Showing {{ GetEventsWithCoordinates().length }} events with location data</p>
      <p *ngIf="loading">Loading map data...</p>
    </div>

    <!-- Map Container -->
    <div class="map-container" style="position: relative;">
      <div id="tracking-map" style="width: 100%; height: 100%;"></div>

      <!-- Loading Overlay -->
      <div class="map-loading-overlay" *ngIf="loading">
        <div class="spinner"></div>
        <p>Refreshing map...</p>
      </div>
    </div>

    <!-- Map Event Details (shown when marker is clicked) -->
    <div class="map-event-details" *ngIf="selectedMapEvent">
      <div class="map-event-header">
        <h3>{{ selectedMapEvent.PartnerName || 'N/A' }}</h3>
        <button class="close-btn" (click)="CloseMapEventDetails()">
          <i class="material-icons">close</i>
        </button>
      </div>

      <div class="map-event-info">
        <div class="info-row">
          <strong>Event Type:</strong> {{ GetEventTypeName(selectedMapEvent.EventType) }}
        </div>
        <div class="info-row">
          <strong>Date & Time:</strong> {{ FormatDate(selectedMapEvent.EventRegister) }}
        </div>
        <div class="info-row">
          <strong>User:</strong> {{ selectedMapEvent.IncomingEmailAddress || 'N/A' }}
        </div>
        <div class="info-row">
          <strong>Grid ID:</strong> {{ selectedMapEvent.GridID }}
        </div>
        <div class="info-row">
          <strong>Location:</strong> {{ selectedMapEvent.Latitude }}, {{ selectedMapEvent.Longitude }}
        </div>
      </div>

      <!-- Grid Lines for Selected Map Event -->
      <div class="map-event-grid-lines" *ngIf="loadingGridLines">
        <div class="spinner-small"></div>
        <p>Loading grid lines...</p>
      </div>

      <div class="map-event-grid-lines" *ngIf="!loadingGridLines && GroupedEvents.length > 0">
        <h4>Grid Events ({{ GroupedEvents.length }})</h4>

        <div *ngFor="let event of GroupedEvents" class="event-group-inline">
          <div class="event-group-header-inline">
            <span class="event-type-badge">{{ GetEventTypeName(event.EventType) }}</span>
            <span class="event-time">{{ FormatDate(event.EventRegister) }}</span>
          </div>

          <!-- AG Grid for this event's lines -->
          <ag-grid-angular
            *ngIf="event.Lines && event.Lines.length > 0"
            style="width: 100%; height: auto;"
            class="ag-theme-alpine"
            [rowData]="event.Lines | eventLinesToGridRows"
            [columnDefs]="columnDefs"
            [gridOptions]="gridOptions"
            [domLayout]="'autoHeight'"
          >
          </ag-grid-angular>

          <div *ngIf="!event.Lines || event.Lines.length === 0" class="no-lines">
            No grid lines for this event
          </div>
        </div>
      </div>

      <div class="map-event-grid-lines" *ngIf="!loadingGridLines && GroupedEvents.length === 0">
        <p>No grid lines found for this event</p>
      </div>
    </div>

    <!-- No Events with Coordinates -->
    <div *ngIf="!loading && GetEventsWithCoordinates().length === 0" class="no-data">
      <i class="material-icons">location_off</i>
      <p>No tracking events with location data found</p>
      <small>Events must have Latitude and Longitude to appear on the map</small>
    </div>
  </div>

  </div><!-- End Searches Tab Content -->

  <!-- Statistics Tab Content -->
  <div class="TabContent" *ngIf="mainTab === 'statistics'">
    <div class="StatisticsBody">

      <!-- ========== PARTNER FILTER ROW ========== -->
      <div class="stats-partner-filter-row">
        <div class="stats-partner-filter-container">
          <div class="stats-partner-label">
            <i class="material-icons">filter_list</i>
            <span>Filter by Partner</span>
          </div>
          <div class="stats-partner-search-wrapper">
            <div class="stats-partner-search-bar">
              <i class="material-icons search-icon">search</i>
              <input
                type="text"
                class="stats-partner-input"
                [(ngModel)]="StatsPartnerSearchTerm"
                (input)="GetStatsPartnersFiltered(StatsPartnerSearchTerm)"
                placeholder="Search..."
              />
              <i *ngIf="StatsSelectedPartner" class="material-icons clear-icon" (click)="ClearStatsPartner()">close</i>
            </div>
            <div class="stats-partner-results" *ngIf="StatsPartners.length > 0">
              <div *ngFor="let partner of StatsPartners" class="stats-partner-result" (click)="SelectStatsPartner(partner)">
                <i class="material-icons">business</i>
                <span class="stats-partner-name">{{ partner.Name }}</span>
              </div>
            </div>
          </div>
          <div class="stats-partner-selected" *ngIf="StatsSelectedPartner">
            <span><strong>{{ StatsSelectedPartner.Name }}</strong></span>
          </div>
        </div>
      </div>

      <!-- ========== VALUES SECTION ========== -->
      <div class="stats-section-header">
        <i class="material-icons">attach_money</i>
        <span>{{ 'B2BTracking.Values' | translate }}</span>
      </div>

      <!-- Values Filter Bar -->
      <div class="stats-filter-bar">
        <!-- Period Dropdown -->
        <div class="filter-field">
          <label>{{ 'B2BTracking.Period' | translate }}</label>
          <div class="CustomDropdownContainer">
            <div class="CustomDropdownBar" (click)="showValuesPeriodDropdown = !showValuesPeriodDropdown">
              <i class="material-icons dropdown-icon-left">date_range</i>
              <input type="text" class="CustomDropdownInput" [value]="valuesPeriod?.Name || ''" readonly placeholder="{{ 'B2BTracking.Period' | translate }}" />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="CustomDropdownResults" *ngIf="showValuesPeriodDropdown">
              <div class="CustomDropdownResult" *ngFor="let period of periodOptions" (click)="OnValuesPeriodChange(period)">
                <div class="CustomDropdownResultMain">
                  <span class="CustomDropdownResultText">{{ period.Name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- From Date -->
        <div class="filter-field">
          <label>{{ 'B2BTracking.FromDate' | translate }}</label>
          <div class="PartnerSearchBar">
            <i class="material-icons search-icon">calendar_today</i>
            <input matInput [matDatepicker]="valuesFromPicker" [formControl]="ValuesFromDate" (dateChange)="OnValuesDateChange()" placeholder="{{ 'B2BTracking.FromDate' | translate }}" class="PartnerSearchInput">
            <mat-datepicker-toggle matSuffix [for]="valuesFromPicker"></mat-datepicker-toggle>
            <mat-datepicker #valuesFromPicker></mat-datepicker>
          </div>
        </div>

        <!-- To Date -->
        <div class="filter-field">
          <label>{{ 'B2BTracking.ToDate' | translate }}</label>
          <div class="PartnerSearchBar">
            <i class="material-icons search-icon">calendar_today</i>
            <input matInput [matDatepicker]="valuesToPicker" [formControl]="ValuesToDate" (dateChange)="OnValuesDateChange()" placeholder="{{ 'B2BTracking.ToDate' | translate }}" class="PartnerSearchInput">
            <mat-datepicker-toggle matSuffix [for]="valuesToPicker"></mat-datepicker-toggle>
            <mat-datepicker #valuesToPicker></mat-datepicker>
          </div>
        </div>

        <!-- Top N Dropdown -->
        <div class="filter-field">
          <label>{{ 'B2BTracking.TopN' | translate }}</label>
          <div class="CustomDropdownContainer">
            <div class="CustomDropdownBar" (click)="showValuesTopNDropdown = !showValuesTopNDropdown">
              <i class="material-icons dropdown-icon-left">format_list_numbered</i>
              <input type="text" class="CustomDropdownInput" [value]="'Top ' + valuesTop" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="CustomDropdownResults" *ngIf="showValuesTopNDropdown">
              <div class="CustomDropdownResult" (click)="SelectValuesTop(5)">
                <div class="CustomDropdownResultMain">
                  <span class="CustomDropdownResultText">Top 5</span>
                </div>
              </div>
              <div class="CustomDropdownResult" (click)="SelectValuesTop(10)">
                <div class="CustomDropdownResultMain">
                  <span class="CustomDropdownResultText">Top 10</span>
                </div>
              </div>
              <div class="CustomDropdownResult" (click)="SelectValuesTop(20)">
                <div class="CustomDropdownResultMain">
                  <span class="CustomDropdownResultText">Top 20</span>
                </div>
              </div>
              <div class="CustomDropdownResult" (click)="SelectValuesTop(50)">
                <div class="CustomDropdownResultMain">
                  <span class="CustomDropdownResultText">Top 50</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Granularity Dropdown -->
        <div class="filter-field">
          <label>{{ 'B2BTracking.Granularity' | translate }}</label>
          <div class="CustomDropdownContainer">
            <div class="CustomDropdownBar" (click)="showValuesGranularityDropdown = !showValuesGranularityDropdown">
              <i class="material-icons dropdown-icon-left">date_range</i>
              <input type="text" class="CustomDropdownInput" [value]="GetValuesGranularityLabel()" readonly />
              <i class="material-icons dropdown-icon">arrow_drop_down</i>
            </div>
            <div class="CustomDropdownResults" *ngIf="showValuesGranularityDropdown">
              <div class="CustomDropdownResult" (click)="SelectValuesGranularity(0)">
                <div class="CustomDropdownResultMain">
                  <i class="material-icons">today</i>
                  <span class="CustomDropdownResultText">{{ 'B2BTracking.Daily' | translate }}</span>
                </div>
              </div>
              <div class="CustomDropdownResult" (click)="SelectValuesGranularity(1)">
                <div class="CustomDropdownResultMain">
                  <i class="material-icons">view_week</i>
                  <span class="CustomDropdownResultText">{{ 'B2BTracking.Weekly' | translate }}</span>
                </div>
              </div>
              <div class="CustomDropdownResult" (click)="SelectValuesGranularity(2)">
                <div class="CustomDropdownResultMain">
                  <i class="material-icons">calendar_view_month</i>
                  <span class="CustomDropdownResultText">{{ 'B2BTracking.Monthly' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Refresh Button -->
        <button class="GridCommandButton GridCommandButtonBlue" (click)="LoadAllValues()">
          <i class="material-icons">refresh</i>
          <span>{{ 'B2BTracking.Refresh' | translate }}</span>
        </button>
      </div>

      <!-- Values Charts Container -->
      <div class="stats-charts-container">
        <!-- Values by Partner Chart -->
        <div class="stats-chart-box">
          <div class="stats-chart-title">
            <i class="material-icons">business</i>
            {{ 'B2BTracking.ValuesByPartner' | translate }}
          </div>
          <div class="stats-chart-body">
            <mat-spinner *ngIf="loadingValuesPartner" [diameter]="30"></mat-spinner>
            <div *ngIf="!loadingValuesPartner && valuesPartnerChartData.length > 0" class="chart-wrapper">
              <canvas baseChart
                [datasets]="valuesPartnerChartData"
                [labels]="valuesPartnerChartLabels"
                [options]="valuesPartnerChartOptions"
                [colors]="valuesPartnerChartColors"
                [chartType]="valuesPartnerChartType">
              </canvas>
            </div>
            <div *ngIf="!loadingValuesPartner && valuesPartnerChartData.length === 0" class="no-data">
              {{ 'B2BTracking.NoData' | translate }}
            </div>
          </div>
        </div>

        <!-- Values by Brand Chart -->
        <div class="stats-chart-box">
          <div class="stats-chart-title">
            <i class="material-icons">label</i>
            {{ 'B2BTracking.ValuesByBrand' | translate }}
          </div>
          <div class="stats-chart-body">
            <mat-spinner *ngIf="loadingValuesBrand" [diameter]="30"></mat-spinner>
            <div *ngIf="!loadingValuesBrand && valuesBrandChartData.length > 0" class="chart-wrapper">
              <canvas baseChart
                [datasets]="valuesBrandChartData"
                [labels]="valuesBrandChartLabels"
                [options]="valuesBrandChartOptions"
                [colors]="valuesBrandChartColors"
                [chartType]="valuesBrandChartType">
              </canvas>
            </div>
            <div *ngIf="!loadingValuesBrand && valuesBrandChartData.length === 0" class="no-data">
              {{ 'B2BTracking.NoData' | translate }}
            </div>
          </div>
        </div>

        <!-- Values Time Series Chart -->
        <div class="stats-chart-box full-width">
          <div class="stats-chart-title">
            <i class="material-icons">timeline</i>
            {{ 'B2BTracking.ValuesOverTime' | translate }}
          </div>
          <div class="stats-chart-body">
            <mat-spinner *ngIf="loadingValuesTimeSeries" [diameter]="30"></mat-spinner>
            <div *ngIf="!loadingValuesTimeSeries && valuesTimeSeriesChartData.length > 0" class="chart-wrapper">
              <canvas baseChart
                [datasets]="valuesTimeSeriesChartData"
                [labels]="valuesTimeSeriesChartLabels"
                [options]="valuesTimeSeriesChartOptions"
                [colors]="valuesTimeSeriesChartColors"
                [chartType]="valuesTimeSeriesChartType">
              </canvas>
            </div>
            <div *ngIf="!loadingValuesTimeSeries && valuesTimeSeriesChartData.length === 0" class="no-data">
              {{ 'B2BTracking.NoData' | translate }}
            </div>
          </div>
        </div>
      </div>

      <!-- ========== SEARCHES SECTION ========== -->
      <div class="stats-section-header">
        <i class="material-icons">search</i>
        <span>{{ 'B2BTracking.Searches' | translate }}</span>
      </div>

      <!-- Charts Container -->
      <div class="stats-charts-container">
        <!-- Partner Chart -->
        <div class="stats-chart-box">
          <div class="stats-chart-title">
            <i class="material-icons">business</i>
            {{ 'B2BTracking.SearchesByPartner' | translate }}
          </div>
          <div class="stats-chart-body">
            <mat-spinner *ngIf="loadingPartnerStats" [diameter]="30"></mat-spinner>
            <div *ngIf="!loadingPartnerStats && partnerChartData.length > 0" class="chart-wrapper">
              <canvas baseChart
                [datasets]="partnerChartData"
                [labels]="partnerChartLabels"
                [options]="partnerChartOptions"
                [colors]="partnerChartColors"
                [chartType]="partnerChartType">
              </canvas>
            </div>
            <div *ngIf="!loadingPartnerStats && partnerChartData.length === 0" class="no-data">
              {{ 'B2BTracking.NoData' | translate }}
            </div>
          </div>
        </div>

        <!-- Brand Chart -->
        <div class="stats-chart-box">
          <div class="stats-chart-title">
            <i class="material-icons">label</i>
            {{ 'B2BTracking.SearchesByBrand' | translate }}
          </div>
          <div class="stats-chart-body">
            <mat-spinner *ngIf="loadingBrandStats" [diameter]="30"></mat-spinner>
            <div *ngIf="!loadingBrandStats && brandChartData.length > 0" class="chart-wrapper">
              <canvas baseChart
                [datasets]="brandChartData"
                [labels]="brandChartLabels"
                [options]="brandChartOptions"
                [colors]="brandChartColors"
                [chartType]="brandChartType">
              </canvas>
            </div>
            <div *ngIf="!loadingBrandStats && brandChartData.length === 0" class="no-data">
              {{ 'B2BTracking.NoData' | translate }}
            </div>
          </div>
        </div>

        <!-- Time Series Chart -->
        <div class="stats-chart-box full-width">
          <div class="stats-chart-title">
            <i class="material-icons">timeline</i>
            {{ 'B2BTracking.SearchesOverTime' | translate }}
          </div>
          <div class="stats-chart-body">
            <mat-spinner *ngIf="loadingTimeSeriesStats" [diameter]="30"></mat-spinner>
            <div *ngIf="!loadingTimeSeriesStats && timeSeriesChartData.length > 0" class="chart-wrapper">
              <canvas baseChart
                [datasets]="timeSeriesChartData"
                [labels]="timeSeriesChartLabels"
                [options]="timeSeriesChartOptions"
                [colors]="timeSeriesChartColors"
                [chartType]="timeSeriesChartType">
              </canvas>
            </div>
            <div *ngIf="!loadingTimeSeriesStats && timeSeriesChartData.length === 0" class="no-data">
              {{ 'B2BTracking.NoData' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Screenshots Tab Content -->
  <div class="TabContent" *ngIf="mainTab === 'screenshots'">

    <!-- Screenshot Filters -->
    <div class="filter-panel open">
      <div class="filter-panel-content">
        <h3>{{ 'B2BTracking.FilterScreenshots' | translate }}</h3>
        <div class="filter-grid">

          <!-- From Date -->
          <div class="filter-field">
            <label>{{ 'B2BTracking.FromDate' | translate }}</label>
            <div class="PartnerSearchBar">
              <i class="material-icons search-icon">calendar_today</i>
              <input matInput [matDatepicker]="ssPickerFrom" [formControl]="ScreenshotFromDate" class="PartnerSearchInput">
              <mat-datepicker-toggle matSuffix [for]="ssPickerFrom"></mat-datepicker-toggle>
              <mat-datepicker #ssPickerFrom></mat-datepicker>
            </div>
          </div>

          <!-- To Date -->
          <div class="filter-field">
            <label>{{ 'B2BTracking.ToDate' | translate }}</label>
            <div class="PartnerSearchBar">
              <i class="material-icons search-icon">calendar_today</i>
              <input matInput [matDatepicker]="ssPickerTo" [formControl]="ScreenshotToDate" class="PartnerSearchInput">
              <mat-datepicker-toggle matSuffix [for]="ssPickerTo"></mat-datepicker-toggle>
              <mat-datepicker #ssPickerTo></mat-datepicker>
            </div>
          </div>

          <!-- Partner Search -->
          <div class="filter-field">
            <label>{{ 'B2BTracking.Partner' | translate }}</label>
            <div class="PartnerSearchContainer">
              <div class="PartnerSearchBar">
                <i class="material-icons search-icon">business</i>
                <input
                  type="text"
                  class="PartnerSearchInput"
                  [(ngModel)]="ScreenshotPartnerSearchTerm"
                  (input)="GetScreenshotPartnersFiltered(ScreenshotPartnerSearchTerm)"
                  [placeholder]="'B2BTracking.SearchPartner' | translate"
                />
                <i *ngIf="ScreenshotSelectedPartner" class="material-icons clear-icon" (click)="ClearScreenshotPartner()">close</i>
              </div>
              <div class="PartnerSearchResults" *ngIf="ScreenshotPartners.length > 0">
                <div
                  *ngFor="let partner of ScreenshotPartners"
                  class="PartnerSearchResult"
                  (click)="SelectScreenshotPartner(partner)"
                >
                  <div class="PartnerResultMain">
                    <span class="PartnerName">{{ partner.Name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Screenshot Type -->
          <div class="filter-field">
            <label>{{ 'B2BTracking.ScreenshotType' | translate }}</label>
            <div class="CustomDropdownContainer">
              <div class="CustomDropdownBar" (click)="showScreenshotTypeDropdown = !showScreenshotTypeDropdown">
                <i class="material-icons dropdown-icon-left">screenshot_monitor</i>
                <input type="text" class="CustomDropdownInput" [class.placeholder]="!ScreenshotTypeFilter"
                       [value]="ScreenshotTypeFilter?.Name || ('B2BTracking.All' | translate)" readonly />
                <i class="material-icons dropdown-icon">arrow_drop_down</i>
              </div>
              <div class="CustomDropdownResults" *ngIf="showScreenshotTypeDropdown">
                <div class="CustomDropdownResult" (click)="SelectScreenshotType(null)">
                  <div class="CustomDropdownResultMain">
                    <span class="CustomDropdownResultText">{{ 'B2BTracking.All' | translate }}</span>
                  </div>
                </div>
                <div class="CustomDropdownResult" (click)="SelectScreenshotType({ID: 1, Name: 'PrintScreen'})">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons">screenshot</i>
                    <span class="CustomDropdownResultText">PrintScreen</span>
                  </div>
                </div>
                <div class="CustomDropdownResult" (click)="SelectScreenshotType({ID: 2, Name: 'Snipping Tool'})">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons">content_cut</i>
                    <span class="CustomDropdownResultText">Snipping Tool</span>
                  </div>
                </div>
                <div class="CustomDropdownResult" (click)="SelectScreenshotType({ID: 3, Name: 'Mac Screenshot'})">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons">laptop_mac</i>
                    <span class="CustomDropdownResultText">Mac Screenshot</span>
                  </div>
                </div>
                <div class="CustomDropdownResult" (click)="SelectScreenshotType({ID: 4, Name: 'Print Page'})">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons">print</i>
                    <span class="CustomDropdownResultText">Print Page</span>
                  </div>
                </div>
                <div class="CustomDropdownResult" (click)="SelectScreenshotType({ID: 5, Name: 'Snip & Sketch'})">
                  <div class="CustomDropdownResultMain">
                    <i class="material-icons">crop</i>
                    <span class="CustomDropdownResultText">Snip & Sketch</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Filter Actions -->
        <div class="filter-actions">
          <button class="filter-btn apply-btn" (click)="GetScreenshotsFiltered(1)">
            <i class="material-icons">search</i>
            {{ 'B2BTracking.ApplyFilter' | translate }}
          </button>
          <button class="filter-btn clear-btn" (click)="ClearScreenshotFilter()">
            <i class="material-icons">clear_all</i>
            {{ 'B2BTracking.ClearFilter' | translate }}
          </button>
        </div>
      </div>
    </div>

    <!-- Screenshots List -->
    <div class="screenshots-list" *ngIf="!loadingScreenshots && Screenshots.length > 0">
      <div class="screenshot-card" *ngFor="let ss of Screenshots" [class.clickable]="ss.ParentGridID" (click)="OpenScreenshotGrid(ss)">
        <div class="screenshot-card-header">
          <div class="screenshot-type-badge" [ngClass]="'type-' + ss.ScreenshotType?.ID">
            <i class="material-icons">{{ getScreenshotTypeIcon(ss.ScreenshotType?.ID) }}</i>
            <span>{{ ss.ScreenshotType?.Name }}</span>
          </div>
          <div class="screenshot-header-right">
            <span class="screenshot-time">{{ ss.EventRegisterUI }}</span>
            <i class="material-icons grid-link-icon" *ngIf="ss.ParentGridID" title="View grid snapshot">grid_on</i>
          </div>
        </div>
        <div class="screenshot-card-body">
          <div class="screenshot-info-row">
            <i class="material-icons">business</i>
            <span class="info-label">{{ 'B2BTracking.Partner' | translate }}:</span>
            <span class="info-value">{{ ss.PartnerName }}</span>
          </div>
          <div class="screenshot-info-row">
            <i class="material-icons">person</i>
            <span class="info-label">{{ 'B2BTracking.User' | translate }}:</span>
            <span class="info-value">{{ ss.UserEmail }}</span>
          </div>
          <div class="screenshot-info-row" *ngIf="ss.IncomingURL">
            <i class="material-icons">link</i>
            <span class="info-label">URL:</span>
            <span class="info-value url-text">{{ ss.IncomingURL }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Screenshot Grid Popup -->
    <div class="screenshot-grid-overlay" *ngIf="SelectedScreenshot" (click)="CloseScreenshotGrid()">
      <div class="screenshot-grid-popup" (click)="$event.stopPropagation()">
        <!-- Popup Header -->
        <div class="screenshot-grid-header">
          <div class="screenshot-grid-title">
            <i class="material-icons">grid_on</i>
            <span>{{ 'B2BTracking.GridSnapshot' | translate }}</span>
            <div class="screenshot-type-badge" [ngClass]="'type-' + SelectedScreenshot.ScreenshotType?.ID">
              <i class="material-icons">{{ getScreenshotTypeIcon(SelectedScreenshot.ScreenshotType?.ID) }}</i>
              <span>{{ SelectedScreenshot.ScreenshotType?.Name }}</span>
            </div>
          </div>
          <div class="screenshot-grid-meta">
            <span><i class="material-icons">business</i> {{ SelectedScreenshot.PartnerName }}</span>
            <span><i class="material-icons">person</i> {{ SelectedScreenshot.UserEmail }}</span>
            <span><i class="material-icons">schedule</i> {{ SelectedScreenshot.EventRegisterUI }}</span>
          </div>
          <button class="screenshot-grid-close" (click)="CloseScreenshotGrid()">
            <i class="material-icons">close</i>
          </button>
        </div>

        <!-- Popup Body -->
        <div class="screenshot-grid-body">
          <!-- Loading -->
          <div class="loading-container" *ngIf="loadingScreenshotGrid">
            <mat-spinner diameter="40"></mat-spinner>
          </div>

          <!-- Grid Events -->
          <div *ngIf="!loadingScreenshotGrid && ScreenshotGridEvents.length > 0">
            <div *ngFor="let event of ScreenshotGridEvents" class="event-group-inline">
              <div class="event-group-header-inline">
                <div class="event-group-title-inline">
                  <i class="material-icons">{{ event.EventType?.ID === 4 || event.EventType?.ID === 5 ? 'download' : 'edit' }}</i>
                  <h4>{{ GetEventTypeName(event.EventType) }}</h4>
                  <span class="event-group-date-inline">{{ FormatDate(event.EventRegister) }}</span>
                </div>
                <span class="badge-inline">{{ event.Lines?.length || 0 }} {{ 'B2BTracking.Lines' | translate }}</span>
              </div>

              <ag-grid-angular
                style="width: 100%;"
                class="ag-theme-alpine"
                [rowData]="event.Lines | eventLinesToGridRows"
                [columnDefs]="columnDefs"
                [gridOptions]="gridOptions"
                [defaultColDef]="{
                  sortable: true,
                  filter: true,
                  resizable: true
                }"
              >
              </ag-grid-angular>
            </div>
          </div>

          <!-- No events -->
          <div *ngIf="!loadingScreenshotGrid && ScreenshotGridEvents.length === 0" class="no-data">
            <i class="material-icons">inbox</i>
            <p>{{ 'B2BTracking.NoGridData' | translate }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div class="loading-container" *ngIf="loadingScreenshots">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <!-- No Data -->
    <div class="no-data" *ngIf="!loadingScreenshots && Screenshots.length === 0">
      {{ 'B2BTracking.NoScreenshots' | translate }}
    </div>

    <!-- Pager -->
    <div class="pager-container" *ngIf="ScreenshotPager && ScreenshotPager.Pages > 1">
      <button class="pager-btn" [disabled]="ScreenshotPager.PageIndex <= 1" (click)="GetScreenshotsFiltered(ScreenshotPager.PageIndex - 1)">
        <i class="material-icons">chevron_left</i>
      </button>
      <span class="pager-info">{{ ScreenshotPager.PageIndex }} / {{ ScreenshotPager.Pages }}</span>
      <button class="pager-btn" [disabled]="ScreenshotPager.PageIndex >= ScreenshotPager.Pages" (click)="GetScreenshotsFiltered(ScreenshotPager.PageIndex + 1)">
        <i class="material-icons">chevron_right</i>
      </button>
      <span class="pager-total">({{ ScreenshotPager.TotalCount }} {{ 'B2BTracking.Total' | translate }})</span>
    </div>

  </div>

</div>